module.exports = __webpack_public_path__ + "img/82a1ada.jpg";